<div class="w-100"
     *ngIf="config">
  <h5 *ngIf="chartTitle"
      class="text-center mb-3">{{ chartTitle }}</h5>

  <rappider-chart-base [config]="config"></rappider-chart-base>

</div>
